/*import { useQuery } from '@tanstack/react-query';
import { fetchCalendarEvents } from '../api/calendar';
import { startOfMonth, endOfMonth, format } from 'date-fns';

const useCalendarEvents = (start, end) => {
    return useQuery({
        queryKey: ['calendarEvents', start, end],
        queryFn: () => fetchCalendarEvents(start, end),
        enabled: !!start && !!end,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });
};

export default useCalendarEvents;*/

// hooks/useCalendarEvents.js
import { useQuery } from '@tanstack/react-query';
import { fetchCalendarEvents } from '../api/calendar';

const DEFAULT_LIMIT = 200;

// ---- Normalizadores (mismos que en useManifestsPaged) ----
const normalizeOptionalNumber = (value) => {
    if (value === undefined || value === null || value === '') return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
};

export const useCalendarEvents = ({
    start,
    end,
    serProInt,
    tipoServicioId,
    tipoServicioCodigo,
    proyectoId,
    estados,
    limit = DEFAULT_LIMIT,
    offset = 0,
    enabled = true,
} = {}) => {
    // ---- Sanitizar / normalizar filtros ----
    const safeLimit = Number.isFinite(Number(limit))
        ? Math.max(Number(limit), 1)
        : DEFAULT_LIMIT;

    const safeOffset = Number.isFinite(Number(offset))
        ? Math.max(Number(offset), 0)
        : 0;

    const safeTipoServicioId = normalizeOptionalNumber(tipoServicioId);
    const safeProyectoId = normalizeOptionalNumber(proyectoId);

    const safeTipoServicioCodigo = tipoServicioCodigo
        ? String(tipoServicioCodigo).trim().toUpperCase()
        : undefined;

    const normalizedEstados = Array.isArray(estados)
        ? [...new Set(estados.map((e) => String(e).trim().toUpperCase()))].sort()
        : undefined;

    const safeSerProInt =
        typeof serProInt === 'boolean' ? serProInt : undefined;

    return useQuery({
        queryKey: [
            'manifests',
            'calendar',
            {
                start,
                end,
                serProInt: safeSerProInt,
                tipoServicioId: safeTipoServicioId,
                tipoServicioCodigo: safeTipoServicioCodigo,
                proyectoId: safeProyectoId,
                estados: normalizedEstados,
                limit: safeLimit,
                offset: safeOffset,
            },
        ],

        queryFn: () =>
            fetchCalendarEvents({
                start,
                end,
                serProInt: safeSerProInt,
                tipoServicioId: safeTipoServicioId,
                tipoServicioCodigo: safeTipoServicioCodigo,
                proyectoId: safeProyectoId,
                estados: normalizedEstados,
                limit: safeLimit,
                offset: safeOffset,
            }),

        select: (response) => ({
            events: Array.isArray(response?.data) ? response.data : [],
            pagination: response?.pagination ?? null,
            filters: response?.filters ?? null,
        }),

        enabled: Boolean(enabled) && !!start && !!end,
        staleTime: 1000 * 60 * 2,
        placeholderData: (previousData) => previousData,

        refetchOnWindowFocus: false,
    });
};

export default useCalendarEvents;
